export const messages = {
  en: {
    integralSetting: {
      title: 'Integral Settings',
      editTitle: 'Edit Integral Settings',
      id: 'ID',
      money: 'Integral Amount',
      onePointEquals: 'One point equals ',
      yuan: ' yuan',
      moneyRequired: 'Integral amount is required',
      moneyMaxLength: 'Integral amount cannot exceed 12 characters',
      moneyPlaceholder: 'Required, please enter the integral amount',
      usage: 'Usage Instructions',
      usageRequired: 'Usage instructions are required',
      usageMaxLength: 'Usage instructions cannot exceed 512 characters',
      usagePlaceholder: 'Required, please enter usage instructions',
      shopping: 'Shopping',
      shoppingRequired: 'Shopping option is required',
      shoppingPlaceholder: 'Required, please select shopping option',
      payment: 'Payment',
      paymentRequired: 'Payment option is required',
      paymentPlaceholder: 'Required, please select payment option'
    }
  },
  zh: {
    integralSetting: {
      title: '积分设置',
      editTitle: '编辑积分设置',
      id: '编号',
      money: '积分金额',
      onePointEquals: '一个积分等于',
      yuan: '元',
      moneyRequired: '积分金额不能为空',
      moneyMaxLength: '积分金额不能超过12个字符',
      moneyPlaceholder: '必填，请填写积分金额',
      usage: '使用说明',
      usageRequired: '使用说明不能为空',
      usageMaxLength: '使用说明不能超过512个字符',
      usagePlaceholder: '必填，请填写使用说明',
      shopping: '购物',
      shoppingRequired: '购物选项不能为空',
      shoppingPlaceholder: '必填，请选择是否购物',
      payment: '缴费',
      paymentRequired: '缴费选项不能为空',
      paymentPlaceholder: '必填，请选择是否缴费'
    }
  }
}